import { ReactElement } from "react";

const GraphAssistantInstructions = (): ReactElement => {
  return (
    <div className="space-y-4">
      <div className="text-sm font-medium text-white">
        Welcome to Miru Copilot
      </div>

      <div className="space-y-2 text-sm text-gray-200">
        <p>
          Copilot helps you accelerate your investigation by working directly
          with selected nodes.
        </p>
      </div>

      <div className="text-sm text-gray-200">
        <p className="mb-2 font-medium text-white">To get started:</p>
        <ol className="ml-2 list-inside list-decimal space-y-1">
          <li>Select one or more nodes in your graph</li>
          <li>Right-click the highlighted nodes</li>
          <li>Choose Ask AI from the context menu</li>
        </ol>
      </div>
      <div className="text-sm text-gray-200">
        <p className="mb-2 font-medium text-white">
          Once attached, Copilot can:
        </p>
        <ul className="ml-2 list-inside list-disc space-y-1">
          <li>Identify suspicious patterns in the selected nodes</li>
          <li>Extract information across related indicators</li>
          <li>Suggest next steps based on your investigation</li>
        </ul>
      </div>
    </div>
  );
};

export default GraphAssistantInstructions;
